module.exports = __webpack_public_path__ + "static/media/Kaufland_Logo.b6857ec4.png";